import { useEffect, useState } from "react";

const STORAGE_KEY = "emjc.cookie-notice.dismissed";

/**
 * Aviso informativo de cookies/RGPD.
 *
 * Este sitio NO usa cookies de seguimiento, analítica de terceros ni publicidad,
 * sólo carga tipografías de Google Fonts. Por eso es suficiente con un aviso
 * informativo (artículo 22.2 LSSI) sin recabar consentimiento previo.
 *
 * Si en el futuro se añade analytics, el banner debe convertirse en un
 * gestor de consentimiento real con opt-in granular antes de cargar scripts.
 */
export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = window.localStorage.getItem(STORAGE_KEY);
      if (!dismissed) setVisible(true);
    } catch {
      // localStorage bloqueado (modo privado / cookies bloqueadas) → mostramos siempre.
      setVisible(true);
    }
  }, []);

  function dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // si no hay almacenamiento, simplemente ocultamos en esta sesión.
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de privacidad"
      className="fixed inset-x-4 bottom-4 z-40 mx-auto max-w-3xl rounded-2xl border border-gray-200 bg-white p-5 shadow-2xl md:inset-x-auto md:left-1/2 md:-translate-x-1/2"
    >
      <p className="text-sm leading-relaxed text-brand-ink">
        Este sitio <strong>no utiliza cookies de seguimiento</strong> ni analítica de terceros.
        Sólo se cargan tipografías de Google Fonts para mostrar el contenido. Más detalle en
        nuestra{" "}
        <a
          href="/cookies"
          className="font-semibold text-brand-orange-deep underline underline-offset-4 decoration-2"
        >
          política de cookies
        </a>
        .
      </p>
      <div className="mt-3 flex justify-end">
        <button
          type="button"
          onClick={dismiss}
          className="rounded-full bg-brand-ink px-5 py-2 text-sm font-semibold text-brand-paper transition hover:bg-brand-orange focus:outline-none focus:ring-2 focus:ring-brand-orange focus:ring-offset-2"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
